import { useState } from "react"
import { Collapse, Icon, Tag } from "@blueprintjs/core"
import React from "react"

export default function ChemicalTable({ inwardAllocations }) {
  const [isOpen, setIsOpen] = useState(true)

  const observations = inwardAllocations?.plotCommoditySample?.observations ?? []

  return (
    <div className="mt-6 rounded-lg overflow-hidden border border-gray-300">
      <div
        className="bg-blue-100 px-4 py-2 flex justify-between items-center cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h6 className="text-blue-600 font-semibold text-sm">
          Chemical Listing
        </h6>
        <Icon icon={isOpen ? "chevron-down" : "chevron-right"} />
      </div>

      <Collapse isOpen={isOpen}>
        <table className="w-full text-sm bg-white">
          <thead style={{ background: "#FFFFFF" }}>
            <tr className="text-xs">
              <th
                className="text-left py-2 px-4 font-500 text-gray-600"
                style={{ borderBottom: "1px solid #D1D5DB" }}
              >
                Quality Parameter
              </th>
              <th
                className="text-left py-2 px-4 font-500 text-gray-600"
                style={{ borderBottom: "1px solid #D1D5DB" }}
              >
                Trace/Alert/Fail (tags)
              </th>
              <th
                className="text-right py-2 px-4 font-500 text-gray-600"
                style={{ borderBottom: "1px solid #D1D5DB" }}
              >
                Detection Count
              </th>

            </tr>
          </thead>
          <tbody style={{ background: "#FFFFFF" }}>
            {observations.length === 0 ? (
              <tr>
                <td
                  colSpan={4}
                  className="text-center py-4 text-gray-500 font-medium"
                >
                  No Observations Available
                </td>
              </tr>
            ) : (
              observations.map((obs, idx) => (
                <tr
                  key={idx}
                  className="hover:bg-gray-50"
                  style={{ borderBottom: "1px solid #D1D5DB" }}
                >
                  <td className="px-4 py-2 font-medium text-gray-800">
                    {obs?.qualityParameter?.name ?? "-"}
                  </td>

                  <td className="px-4 py-2 text-left">
                    <Tag
                      minimal
                      round
                      intent={
                        obs?.tags?.includes("fail")
                          ? "danger"
                          : obs?.tags?.includes("alert")
                            ? "warning"
                            : obs?.tags?.includes("trace")
                              ? "success"
                              : "primary"
                      }
                    >
                      {obs?.tags?.includes("fail")
                        ? "FAIL"
                        : obs?.tags?.includes("alert")
                          ? "ALERT"
                          : obs?.tags?.includes("trace")
                            ? "Trace"
                            : obs?.tags?.join(", ").toUpperCase() || "-"}
                    </Tag>
                  </td>
                  <td className="px-4 py-2 text-right">
                    {obs?.detectionCount ?? "-"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </Collapse>
    </div>
  )
}
